const diagnosisStatus = {
  Yes: 1,
  No: 2,
  Unknown: 3
}

export default diagnosisStatus;